import { Typography, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
import { highlightStyles } from 'app/domains/global-search/components/styled';
export const TextWrapper = styled.div `
  display: flex;
  flex-direction: column;
`;
export const StyledTypography = styled(Typography) `
  text-decoration: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }

  mark {
    ${highlightStyles}
  }
`;
export const Container = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${themeGet('spacing.md')};
`;
